const filterKeys = [
  'luxPlusFeatures',
  'holidayTypes',
  'priceGte',
  'priceLte',
  'amenities',
  'inclusions',
  'bedroomsEq',
  'bedsEq',
  'bathroomsEq',
  'customerRatingGte',
  'offerTypes',
]

/**
 * Checks if any filter properties have changed between previous and current filters
 * @param {object} params - Object containing previousFilters and currentFilters
 * @returns {boolean} - True if any filter property has changed, false otherwise
 */
export function hasFilterChanged({ previousFilters, currentFilters }: {
  previousFilters?: App.OfferListFilters
  currentFilters: App.OfferListFilters
}): boolean {
  if (!previousFilters) return false

  return filterKeys.some(key => {
    const prevValue = previousFilters[key as keyof App.OfferListFilters]
    const currValue = currentFilters[key as keyof App.OfferListFilters]

    // Handle array comparison
    if (Array.isArray(prevValue) && Array.isArray(currValue)) {
      if (prevValue.length !== currValue.length) return true
      return prevValue.some((item, index) => item !== currValue[index])
    }

    // Handle primitive comparison
    return prevValue !== currValue
  })
}
